import { render, staticRenderFns } from "./purchased-item.vue?vue&type=template&id=5ae4fff9&scoped=true&"
import script from "./purchased-item.vue?vue&type=script&lang=js&"
export * from "./purchased-item.vue?vue&type=script&lang=js&"
import style0 from "./purchased-item.vue?vue&type=style&index=0&id=5ae4fff9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae4fff9",
  null
  
)

export default component.exports